import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate, useSearchParams } from "react-router-dom";
import Login from "./components/Auth/Login";
import ApproveAccount from "./components/Auth/ApproveAccount";
import ConfirmUser from "./components/Auth/ConfirmUser";
import ResetPassword from "./components/Auth/ResetPassword";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:2021/api";

/**
 * Redirects the browser to the backend GET /api/auth/logout endpoint,
 * forwarding redirect and appId query params.
 */
const Logout = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const params = new URLSearchParams();
    const redirect = searchParams.get("redirect");
    const appId = searchParams.get("appId");
    if (redirect) params.set("redirect", redirect);
    if (appId) params.set("appId", appId);

    const qs = params.toString();
    window.location.href = `${API_URL}/auth/logout${qs ? `?${qs}` : ""}`;
  }, [searchParams]);

  return null;
};

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/confirmUser" element={<ConfirmUser />} />
      <Route path="/confirmForgotPassword" element={<ResetPassword />} />
      <Route path="/auth/approve" element={<ApproveAccount />} />
      <Route path="/auth/logout" element={<Logout />} />
    </Routes>
  </BrowserRouter>
);

export default App;
